/**
 * Shared types for the ItemList component system.
 */

/** Normalized item — all DynamoDB `.S`/`.N` unwrapped */
export interface NormalizedItem {
  id: string;
  title: string;
  name?: string;
  itemtype: 'resource' | 'folder' | 'project';
  type?: string; // file type: 'video' | 'audio' | 'image' | 'doc' | etc.
  created: string;
  owner?: string;
  parent?: string;
  parentType?: string;
  groupId?: string;
  // File-specific
  signedUrl?: string;
  thumbnailUrl?: string;
  snapshotUrl?: string;
  mimeType?: string;
  size?: string;
  key?: string;
  ext?: string;
  preview?: boolean;
  isRendable?: boolean;
  // Folder/project-specific
  previewImages?: unknown[];
  resources?: Record<string, number> | unknown[];
  image?: string;
  breadcrumb?: unknown;
  breadcrumbs?: unknown;
  searchField?: string;
  status?: string;
}

export type SortCriteria = 'date' | 'name' | 'type';

export type ModalType =
  | 'delete'
  | 'rename'
  | 'move'
  | 'copy'
  | 'fileUpload'
  | 'newItem'
  | 'shareFile'
  | 'coverImage'
  | 'convert';

export interface ModalState {
  type: ModalType;
  params?: unknown;
}

export interface PermissionSet {
  canEdit: boolean;
  canDelete: boolean;
  canShare: boolean;
  canUpload: boolean;
  canMove: boolean;
  canCopy: boolean;
}

export function getPermissions(
  userRole?: string | null,
  useCase?: string,
): PermissionSet {
  if (useCase === 'link') {
    return { canEdit: false, canDelete: false, canShare: false, canUpload: false, canMove: false, canCopy: false };
  }
  const isViewer = userRole === 'viewer' || userRole === 'guest';
  return {
    canEdit: !isViewer,
    canDelete: !isViewer,
    canShare: !isViewer,
    canUpload: !isViewer,
    canMove: !isViewer,
    canCopy: !isViewer,
  };
}
